/** @format */

import React, { Component } from 'react';
import { Divider } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';

@inject('StatsStore')
@observer
class MostSoldParts extends Component {
  renderPartList = mostSoldParts => {
    return mostSoldParts.map(part => {
      return (
        <div className="simple-list" key={part.name}>
          <div className="simple-list-item">
            <div>{part.name}</div>
            <div>{part.value}</div>
          </div>
          <Divider fitted />
        </div>
      );
    });
  };

  render() {
    const { StatsStore } = this.props;
    const mostSoldParts = StatsStore.mostSoldParts;

    return <div>{this.renderPartList(mostSoldParts)}</div>;
  }
}

export default MostSoldParts;
